import { render, staticRenderFns } from "./DynamicTextArea.vue?vue&type=template&id=7af9155a&scoped=true&"
import script from "./DynamicTextArea.vue?vue&type=script&lang=js&"
export * from "./DynamicTextArea.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTextArea.vue?vue&type=style&index=0&id=7af9155a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9155a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
